import './App.scss';
import React, {Suspense, useEffect} from 'react';
import { useDispatch } from 'react-redux';

import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";

import ProtectedRoute from './routes/ProtectedRoute';
import LoadingSpinner from "./components/LoadingSpinner";
import AppContainer from "./containers/app-container/AppContainer";
import PublicRoute from "./routes/PublicRoute";
import LoginPage from "./containers/auth/LoginPage";
import NotFoundContainer from "./containers/not-found/NotFound";
import Info from "./containers/info/Info";
import Dashboard from "./containers/dashboard/Dashboard";
import Customers from "./containers/customers/Customers";
import Product from "./containers/product/Product";
import News from "./containers/news/News";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import OrderDetailsPage from "./containers/order/OrderDetailsPage";
import OrderSearchPage from "./containers/order/OrderSearchPage";
import ContextPage from "./components/ContextPage";
import CalculationSearchPage from "./containers/calculations/CalculationSearchPage";
import CalculationDetailsPage from "./containers/calculations/CalculationDetailsPage";
import FinancialPage from "./containers/financial/FinancialPage";
import { fetchAllUsersRequest } from './store/user/actions/user-actions';
import UsersPage from "./containers/users/UsersPage";
import BoardSearchPage from "./containers/boards/BoardSearchPage";
import BoardDetailsPage from "./containers/boards/BoardDetailsPage";


const App = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAllUsersRequest());
    }, [dispatch]);

    return (
        <BrowserRouter>
            <Suspense fallback={<LoadingSpinner/>}>
                <Routes>
                    <Route element={<ProtectedRoute/>}>
                        <Route path="/" element={<AppContainer/>}>
                            <Route index path="/dashboard" element={<Dashboard/>}/>
                            <Route path="/messages" element={<Info/>}/>
                            <Route path="/orders" element={<ContextPage/>}>
                                <Route index element={<OrderSearchPage />} />
                                <Route path=":id" element={<OrderDetailsPage />} />
                            </Route>
                            <Route path="/customers" element={<Customers/>}/>
                            <Route path="/product" element={<Product/>}/>
                            <Route path="/calculations" element={<ContextPage/>}>
                                <Route index element={<CalculationSearchPage />} />
                                <Route path=":id" element={<CalculationDetailsPage />} />
                            </Route>
                            <Route path="/financial" element={<FinancialPage/>}/>
                            <Route path="/users" element={<UsersPage/>}/>
                            <Route path="/news" element={<News/>}/>
                            <Route path="/boards" element={<ContextPage/>}>
                                <Route index element={<BoardSearchPage />} />
                                <Route path=":id" element={<BoardDetailsPage />} />
                            </Route>
                        </Route>
                    </Route>
                    <Route element={<PublicRoute/>}>
                        <Route path="/login"  element={<LoginPage/>}/>
                        <Route path="/logged-out" element={
                            <div>You are logged out</div>
                        }
                        />
                    </Route>
                    <Route path="*" element={<NotFoundContainer/>}/>
                </Routes>
            </Suspense>
            <ToastContainer style={{whiteSpace: "pre-line"}} position="top-right" autoClose={3000} />
        </BrowserRouter>
    );
};


export default App;
